// extracted by mini-css-extract-plugin
export var wrapper = "OverlayImageLeft-module--wrapper--fced5";
export var wrapperImage = "OverlayImageLeft-module--wrapperImage--1f387";